import { lazyImport } from 'src/_shared/utils/lazy-import/lazyImport';

export enum ICON_NAMES {
  AddFrame = 'add-frame',
  AddPage = 'add-page',
  AddPhoto = 'add-photo',
  AddToCart = 'add-to-cart',
  Alert = 'alert',
  Apple = 'apple',
  ArrowBottom = 'arrow-bottom',
  ArrowLeft1 = 'arrow-left-1',
  ArrowLeft2 = 'arrow-left-2',
  ArrowRight1 = 'arrow-right-1',
  ArrowRight2 = 'arrow-right-2',
  ArtificialIntelligence = 'artificial-intelligence',
  Assistance = 'assistance',
  AutoCorrection = 'auto-correction',
  Background = 'background',
  Bag = 'bag',
  Bell = 'bell',
  BellRing = 'bell-ring',
  Border = 'border',
  Box = 'box',
  Brush = 'brush',
  Calendar = 'calendar',
  Camera = 'camera',
  CameraFlash = 'camera-flash',
  Cart = 'cart',
  ChangeImage = 'change-image',
  ChangeType = 'change-type',
  Chat = 'chat',
  ChatAI = 'chat-ai',
  Check = 'check',
  Circle = 'circle',
  Close = 'close',
  Contrast = 'contrast',
  Copy = 'copy',
  CopyText = 'copy-text',
  CounterClockwise = 'counter-clockwise',
  Crop = 'crop',
  Crop2 = 'crop-2',
  Delete = 'delete',
  Delivery = 'delivery',
  Desktop = 'desktop',
  DiscountSimpleV1 = 'discount-simple-variant-1',
  DiscountSimpleV2 = 'discount-simple-variant-2',
  DiscountSimpleV3 = 'discount-simple-variant-3',
  Discount = 'discount',
  Drag = 'drag',
  Drop = 'drop',
  Drop2 = 'drop-2',
  Edge = 'edge',
  Edit = 'edit',
  Error = 'error',
  Exit = 'exit',
  Expand = 'expand',
  Eye = 'eye',
  EyeBarred = 'eye-barred',
  Facebook = 'facebook',
  Faq = 'faq',
  Filters = 'filters',
  Filters2 = 'filters2',
  Focus = 'focus',
  Folder = 'folder',
  FrameColor = 'frame-color',
  Gallery = 'gallery',
  Gift = 'gift',
  GiftCard = 'gift-card',
  Glass = 'glass',
  Google = 'google',
  GooglePhoto = 'google-photo',
  Help = 'help',
  Home = 'home',
  Info = 'info',
  Info1 = 'info-1',
  Lamp = 'lamp',
  Layout = 'layout',
  Logout = 'logout',
  Magic = 'magic',
  Mail = 'mail',
  Menu = 'menu',
  Minus = 'minus',
  Moon = 'moon',
  MoreVertical = 'more-vertical',
  More = 'more',
  NoInternet = 'no-internet',
  Palette = 'palette',
  PassepartoutColor = 'passepartout-color',
  Pc = 'pc',
  PencilRuler = 'pencil-ruler',
  People2 = 'people-2',
  People3 = 'people-3',
  Person = 'person',
  PhotoAlbum = 'photo-album',
  PhotosiLogo = 'photosi-logo',
  PhotosiB2bLogo = 'photosi-b2b-logo',
  PhotosiStars = 'photosi-stars',
  Picker = 'picker',
  Picture = 'picture',
  Plus = 'plus',
  Printer = 'printer',
  Redo = 'redo',
  Refresh = 'refresh',
  Request = 'request',
  RotateDx = 'rotate-dx',
  RotateSx = 'rotate-sx',
  Ruler2Off = 'ruler-2-off',
  Ruler2 = 'ruler-2',
  Ruler = 'ruler',
  Saved = 'saved',
  Search = 'search',
  Setting = 'setting',
  Settings = 'settings',
  Settings2 = 'settings-2',
  SimpleChat = 'simple-chat',
  Smartphone1 = 'smartphone1',
  Smartphone2 = 'smartphone2',
  Smile = 'smile',
  Space = 'space',
  Square = 'square',
  Sticker = 'sticker',
  Subscription = 'subscription',
  Sun = 'sun',
  Tablet = 'tablet',
  Text = 'text',
  TextDesign = 'text-design',
  Thickness = 'thickness',
  Transfer = 'transfer',
  Travel = 'travel',
  Undo = 'undo',
  ZoomMinus = 'zoom-minus',
  ZoomPlus = 'zoom-plus',
  Flower = 'flower',
  Book = 'book',
  Share = 'share',
  Star = 'star',
  Retailer = 'retailer',
  ChatAI2 = 'chat-ai-2',
  Multiselect = 'multiselect',
  GridView1 = 'grid-view-1',
  GridView2 = 'grid-view-2',
  GridView3 = 'grid-view-3',
  GridView4 = 'grid-view-4',
  SideColor = 'side-color',
  Upload = 'upload',
  Cloud = 'cloud',
  Saving = 'saving',
  ChatAIGradient = 'chat-ai-gradient',
  ChatOld = 'chat-old',
  ChatOldClose = 'chat-old-close',
  NoCut = 'no-cut',
  Promo = 'promo',
  Cut = 'cut',
  Rearrange = 'rearrange',
  Incognito = 'incognito',
  FlipHorizontal = 'flip-horizontal',
  FlipVertical = 'flip-vertical',
  NoColor = 'no-color',
  CutAlert = 'cut-alert',
  CutConfirmationAlert = 'cut-confirmation-alert',
  Orientation = 'orientation',
  Question1 = 'question-1',
  PhotoPaper = 'photo-paper',
  GridView25 = 'grid-view-2-5',
  SelectAll = 'select-all',
  FormatTextAlignCenter = 'icon-text-align-center',
  FormatTextAlignLeft = 'icon-text-align-left',
  FormatTextAlignRight = 'icon-text-align-right',
  IconText = 'default-icon-text',
  Link = 'icon-link',
  PrintType = 'printtype',
  NotificationBadge = 'notification-badge',
  IncognitoModeAlert = 'incognito-mode-alert',
  NotSupportedEnvAlert = 'not-supported-env-alert',
  KitType = 'kit-type',
  CheckCircle = 'check-circle',
}

export const iconLibrary = {
  [ICON_NAMES.AddFrame]: lazyImport(() => import('./library/AddFrame'), 'AddFrame'),
  [ICON_NAMES.AddPage]: lazyImport(() => import('./library/AddPage'), 'AddPage'),
  [ICON_NAMES.AddPhoto]: lazyImport(() => import('./library/AddPhoto'), 'AddPhoto'),
  [ICON_NAMES.AddToCart]: lazyImport(() => import('./library/AddToCart'), 'AddToCart'),
  [ICON_NAMES.Alert]: lazyImport(() => import('./library/Alert'), 'Alert'),
  [ICON_NAMES.Apple]: lazyImport(() => import('./library/Apple'), 'Apple'),
  [ICON_NAMES.ArrowBottom]: lazyImport(() => import('./library/ArrowBottom'), 'ArrowBottom'),
  [ICON_NAMES.ArrowLeft1]: lazyImport(() => import('./library/ArrowLeft1'), 'ArrowLeft1'),
  [ICON_NAMES.ArrowLeft2]: lazyImport(() => import('./library/ArrowLeft2'), 'ArrowLeft2'),
  [ICON_NAMES.ArrowRight1]: lazyImport(() => import('./library/ArrowRight1'), 'ArrowRight1'),
  [ICON_NAMES.ArrowRight2]: lazyImport(() => import('./library/ArrowRight2'), 'ArrowRight2'),
  [ICON_NAMES.ArtificialIntelligence]: lazyImport(
    () => import('./library/ArtificialIntelligence'),
    'ArtificialIntelligence',
  ),
  [ICON_NAMES.Assistance]: lazyImport(() => import('./library/Assistance'), 'Assistance'),
  [ICON_NAMES.AutoCorrection]: lazyImport(() => import('./library/AutoCorrection'), 'AutoCorrection'),
  [ICON_NAMES.Background]: lazyImport(() => import('./library/Background'), 'Background'),
  [ICON_NAMES.Bag]: lazyImport(() => import('./library/Bag'), 'Bag'),
  [ICON_NAMES.Bell]: lazyImport(() => import('./library/Bell'), 'Bell'),
  [ICON_NAMES.BellRing]: lazyImport(() => import('./library/BellRing'), 'BellRing'),
  [ICON_NAMES.Border]: lazyImport(() => import('./library/Border'), 'Border'),
  [ICON_NAMES.Box]: lazyImport(() => import('./library/Box'), 'Box'),
  [ICON_NAMES.Brush]: lazyImport(() => import('./library/Brush'), 'Brush'),
  [ICON_NAMES.Calendar]: lazyImport(() => import('./library/Calendar'), 'Calendar'),
  [ICON_NAMES.Camera]: lazyImport(() => import('./library/Camera'), 'Camera'),
  [ICON_NAMES.CameraFlash]: lazyImport(() => import('./library/CameraFlash'), 'CameraFlash'),
  [ICON_NAMES.Cart]: lazyImport(() => import('./library/Cart'), 'Cart'),
  [ICON_NAMES.ChangeImage]: lazyImport(() => import('./library/ChangeImage'), 'ChangeImage'),
  [ICON_NAMES.ChangeType]: lazyImport(() => import('./library/ChangeType'), 'ChangeType'),
  [ICON_NAMES.Chat]: lazyImport(() => import('./library/Chat'), 'Chat'),
  [ICON_NAMES.ChatAI]: lazyImport(() => import('./library/ChatAI'), 'ChatAI'),
  [ICON_NAMES.Check]: lazyImport(() => import('./library/Check'), 'Check'),
  [ICON_NAMES.Circle]: lazyImport(() => import('./library/Circle'), 'Circle'),
  [ICON_NAMES.Close]: lazyImport(() => import('./library/Close'), 'Close'),
  [ICON_NAMES.Contrast]: lazyImport(() => import('./library/Contrast'), 'Contrast'),
  [ICON_NAMES.Copy]: lazyImport(() => import('./library/Copy'), 'Copy'),
  [ICON_NAMES.CopyText]: lazyImport(() => import('./library/CopyText'), 'CopyText'),
  [ICON_NAMES.CounterClockwise]: lazyImport(() => import('./library/CounterClockwise'), 'CounterClockwise'),
  [ICON_NAMES.Crop]: lazyImport(() => import('./library/Crop'), 'Crop'),
  [ICON_NAMES.Crop2]: lazyImport(() => import('./library/Crop2'), 'Crop2'),
  [ICON_NAMES.Delete]: lazyImport(() => import('./library/Delete'), 'Delete'),
  [ICON_NAMES.Delivery]: lazyImport(() => import('./library/Delivery'), 'Delivery'),
  [ICON_NAMES.Desktop]: lazyImport(() => import('./library/Desktop'), 'Desktop'),
  [ICON_NAMES.DiscountSimpleV1]: lazyImport(() => import('./library/DiscountSimpleV1'), 'DiscountSimpleV1'),
  [ICON_NAMES.DiscountSimpleV2]: lazyImport(() => import('./library/DiscountSimpleV2'), 'DiscountSimpleV2'),
  [ICON_NAMES.DiscountSimpleV3]: lazyImport(() => import('./library/DiscountSimpleV3'), 'DiscountSimpleV3'),
  [ICON_NAMES.Discount]: lazyImport(() => import('./library/Discount'), 'Discount'),
  [ICON_NAMES.Drag]: lazyImport(() => import('./library/Drag'), 'Drag'),
  [ICON_NAMES.Drop]: lazyImport(() => import('./library/Drop'), 'Drop'),
  [ICON_NAMES.Drop2]: lazyImport(() => import('./library/Drop2'), 'Drop2'),
  [ICON_NAMES.Edge]: lazyImport(() => import('./library/Edge'), 'Edge'),
  [ICON_NAMES.Edit]: lazyImport(() => import('./library/Edit'), 'Edit'),
  [ICON_NAMES.Error]: lazyImport(() => import('./library/Error'), 'Error'),
  [ICON_NAMES.Exit]: lazyImport(() => import('./library/Exit'), 'Exit'),
  [ICON_NAMES.Expand]: lazyImport(() => import('./library/Expand'), 'Expand'),
  [ICON_NAMES.Eye]: lazyImport(() => import('./library/Eye'), 'Eye'),
  [ICON_NAMES.EyeBarred]: lazyImport(() => import('./library/EyeBarred'), 'EyeBarred'),
  [ICON_NAMES.Facebook]: lazyImport(() => import('./library/Facebook'), 'Facebook'),
  [ICON_NAMES.Faq]: lazyImport(() => import('./library/Faq'), 'Faq'),
  [ICON_NAMES.Filters]: lazyImport(() => import('./library/Filters'), 'Filters'),
  [ICON_NAMES.Filters2]: lazyImport(() => import('./library/Filters2'), 'Filters2'),
  [ICON_NAMES.Focus]: lazyImport(() => import('./library/Focus'), 'Focus'),
  [ICON_NAMES.Folder]: lazyImport(() => import('./library/Folder'), 'Folder'),
  [ICON_NAMES.FrameColor]: lazyImport(() => import('./library/FrameColor'), 'FrameColor'),
  [ICON_NAMES.Gallery]: lazyImport(() => import('./library/Gallery'), 'Gallery'),
  [ICON_NAMES.Gift]: lazyImport(() => import('./library/Gift'), 'Gift'),
  [ICON_NAMES.GiftCard]: lazyImport(() => import('./library/GiftCard'), 'GiftCard'),
  [ICON_NAMES.Glass]: lazyImport(() => import('./library/Glass'), 'Glass'),
  [ICON_NAMES.Google]: lazyImport(() => import('./library/Google'), 'Google'),
  [ICON_NAMES.GooglePhoto]: lazyImport(() => import('./library/GooglePhoto'), 'GooglePhoto'),
  [ICON_NAMES.Help]: lazyImport(() => import('./library/Help'), 'Help'),
  [ICON_NAMES.Home]: lazyImport(() => import('./library/Home'), 'Home'),
  [ICON_NAMES.Info]: lazyImport(() => import('./library/Info'), 'Info'),
  [ICON_NAMES.Info1]: lazyImport(() => import('./library/Info1'), 'Info1'),
  [ICON_NAMES.Lamp]: lazyImport(() => import('./library/Lamp'), 'Lamp'),
  [ICON_NAMES.Layout]: lazyImport(() => import('./library/Layout'), 'Layout'),
  [ICON_NAMES.Logout]: lazyImport(() => import('./library/Logout'), 'Logout'),
  [ICON_NAMES.Magic]: lazyImport(() => import('./library/Magic'), 'Magic'),
  [ICON_NAMES.Mail]: lazyImport(() => import('./library/Mail'), 'Mail'),
  [ICON_NAMES.Menu]: lazyImport(() => import('./library/Menu'), 'Menu'),
  [ICON_NAMES.Minus]: lazyImport(() => import('./library/Minus'), 'Minus'),
  [ICON_NAMES.Moon]: lazyImport(() => import('./library/Moon'), 'Moon'),
  [ICON_NAMES.MoreVertical]: lazyImport(() => import('./library/MoreVertical'), 'MoreVertical'),
  [ICON_NAMES.More]: lazyImport(() => import('./library/More'), 'More'),
  [ICON_NAMES.NoInternet]: lazyImport(() => import('./library/NoInternet'), 'NoInternet'),
  [ICON_NAMES.Palette]: lazyImport(() => import('./library/Palette'), 'Palette'),
  [ICON_NAMES.PassepartoutColor]: lazyImport(() => import('./library/PassepartoutColor'), 'PassepartoutColor'),
  [ICON_NAMES.Pc]: lazyImport(() => import('./library/Pc'), 'Pc'),
  [ICON_NAMES.PencilRuler]: lazyImport(() => import('./library/PencilRuler'), 'PencilRuler'),
  [ICON_NAMES.People2]: lazyImport(() => import('./library/People2'), 'People2'),
  [ICON_NAMES.People3]: lazyImport(() => import('./library/People3'), 'People3'),
  [ICON_NAMES.Person]: lazyImport(() => import('./library/Person'), 'Person'),
  [ICON_NAMES.PhotoAlbum]: lazyImport(() => import('./library/PhotoAlbum'), 'PhotoAlbum'),
  [ICON_NAMES.PhotosiLogo]: lazyImport(() => import('./library/photosi-logo'), 'PhotosiLogo'),
  [ICON_NAMES.PhotosiB2bLogo]: lazyImport(() => import('./library/photosi-b2b-logo'), 'PhotosiB2bLogo'),
  [ICON_NAMES.PhotosiStars]: lazyImport(() => import('./library/PhotosiStars'), 'PhotosiStars'),
  [ICON_NAMES.Picker]: lazyImport(() => import('./library/Picker'), 'Picker'),
  [ICON_NAMES.Picture]: lazyImport(() => import('./library/Picture'), 'Picture'),
  [ICON_NAMES.Plus]: lazyImport(() => import('./library/Plus'), 'Plus'),
  [ICON_NAMES.Printer]: lazyImport(() => import('./library/Printer'), 'Printer'),
  [ICON_NAMES.Redo]: lazyImport(() => import('./library/Redo'), 'Redo'),
  [ICON_NAMES.Refresh]: lazyImport(() => import('./library/Refresh'), 'Refresh'),
  [ICON_NAMES.Request]: lazyImport(() => import('./library/Request'), 'Request'),
  [ICON_NAMES.RotateDx]: lazyImport(() => import('./library/RotateDx'), 'RotateDx'),
  [ICON_NAMES.RotateSx]: lazyImport(() => import('./library/RotateSx'), 'RotateSx'),
  [ICON_NAMES.Ruler2Off]: lazyImport(() => import('./library/Ruler2Off'), 'Ruler2Off'),
  [ICON_NAMES.Ruler2]: lazyImport(() => import('./library/Ruler2'), 'Ruler2'),
  [ICON_NAMES.Ruler]: lazyImport(() => import('./library/Ruler'), 'Ruler'),
  [ICON_NAMES.Saved]: lazyImport(() => import('./library/Saved'), 'Saved'),
  [ICON_NAMES.Search]: lazyImport(() => import('./library/Search'), 'Search'),
  [ICON_NAMES.Setting]: lazyImport(() => import('./library/Setting'), 'Setting'),
  [ICON_NAMES.Settings]: lazyImport(() => import('./library/Settings'), 'Settings'),
  [ICON_NAMES.Settings2]: lazyImport(() => import('./library/Settings2'), 'Settings2'),
  [ICON_NAMES.SimpleChat]: lazyImport(() => import('./library/SimpleChat'), 'SimpleChat'),
  [ICON_NAMES.Smartphone1]: lazyImport(() => import('./library/Smartphone1'), 'Smartphone1'),
  [ICON_NAMES.Smartphone2]: lazyImport(() => import('./library/Smartphone2'), 'Smartphone2'),
  [ICON_NAMES.Smile]: lazyImport(() => import('./library/Smile'), 'Smile'),
  [ICON_NAMES.Space]: lazyImport(() => import('./library/Space'), 'Space'),
  [ICON_NAMES.Square]: lazyImport(() => import('./library/Square'), 'Square'),
  [ICON_NAMES.Sticker]: lazyImport(() => import('./library/Sticker'), 'Sticker'),
  [ICON_NAMES.Subscription]: lazyImport(() => import('./library/Subscription'), 'Subscription'),
  [ICON_NAMES.Sun]: lazyImport(() => import('./library/Sun'), 'Sun'),
  [ICON_NAMES.Tablet]: lazyImport(() => import('./library/Tablet'), 'Tablet'),
  [ICON_NAMES.Text]: lazyImport(() => import('./library/Text'), 'Text'),
  [ICON_NAMES.TextDesign]: lazyImport(() => import('./library/TextDesign'), 'TextDesign'),
  [ICON_NAMES.Thickness]: lazyImport(() => import('./library/Thickness'), 'Thickness'),
  [ICON_NAMES.Transfer]: lazyImport(() => import('./library/Transfer'), 'Transfer'),
  [ICON_NAMES.Travel]: lazyImport(() => import('./library/Travel'), 'Travel'),
  [ICON_NAMES.Undo]: lazyImport(() => import('./library/Undo'), 'Undo'),
  [ICON_NAMES.ZoomMinus]: lazyImport(() => import('./library/ZoomMinus'), 'ZoomMinus'),
  [ICON_NAMES.ZoomPlus]: lazyImport(() => import('./library/ZoomPlus'), 'ZoomPlus'),
  [ICON_NAMES.Flower]: lazyImport(() => import('./library/Flower'), 'Flower'),
  [ICON_NAMES.Book]: lazyImport(() => import('./library/Book'), 'Book'),
  [ICON_NAMES.Share]: lazyImport(() => import('./library/Share'), 'Share'),
  [ICON_NAMES.Star]: lazyImport(() => import('./library/Star'), 'Star'),
  [ICON_NAMES.Retailer]: lazyImport(() => import('./library/Retailer'), 'Retailer'),
  [ICON_NAMES.ChatAI2]: lazyImport(() => import('./library/ChatAI2'), 'ChatAI2'),
  [ICON_NAMES.Multiselect]: lazyImport(() => import('./library/Multiselect'), 'Multiselect'),
  [ICON_NAMES.GridView1]: lazyImport(() => import('./library/GridView1'), 'GridView1'),
  [ICON_NAMES.GridView2]: lazyImport(() => import('./library/GridView2'), 'GridView2'),
  [ICON_NAMES.GridView3]: lazyImport(() => import('./library/GridView3'), 'GridView3'),
  [ICON_NAMES.GridView4]: lazyImport(() => import('./library/GridView4'), 'GridView4'),
  [ICON_NAMES.SideColor]: lazyImport(() => import('./library/SideColor'), 'SideColor'),
  [ICON_NAMES.Upload]: lazyImport(() => import('./library/Upload'), 'Upload'),
  [ICON_NAMES.Cloud]: lazyImport(() => import('./library/Cloud'), 'Cloud'),
  [ICON_NAMES.Saving]: lazyImport(() => import('./library/Saving'), 'Saving'),
  [ICON_NAMES.ChatAIGradient]: lazyImport(() => import('./library/ChatAIGradient'), 'ChatAIGradient'),
  [ICON_NAMES.ChatOld]: lazyImport(() => import('./library/ChatOld'), 'ChatOld'),
  [ICON_NAMES.ChatOldClose]: lazyImport(() => import('./library/ChatOldClose'), 'ChatOldClose'),
  [ICON_NAMES.NoCut]: lazyImport(() => import('./library/NoCut'), 'NoCut'),
  [ICON_NAMES.Promo]: lazyImport(() => import('./library/Promo'), 'Promo'),
  [ICON_NAMES.Cut]: lazyImport(() => import('./library/Cut'), 'Cut'),
  [ICON_NAMES.Rearrange]: lazyImport(() => import('./library/Rearrange'), 'Rearrange'),
  [ICON_NAMES.Incognito]: lazyImport(() => import('./library/Incognito'), 'Incognito'),
  [ICON_NAMES.FlipHorizontal]: lazyImport(() => import('./library/FlipHorizontal'), 'FlipHorizontal'),
  [ICON_NAMES.FlipVertical]: lazyImport(() => import('./library/FlipVertical'), 'FlipVertical'),
  [ICON_NAMES.NoColor]: lazyImport(() => import('./library/NoColor'), 'NoColor'),
  [ICON_NAMES.CutAlert]: lazyImport(() => import('./library/CutAlert'), 'CutAlert'),
  [ICON_NAMES.CutConfirmationAlert]: lazyImport(() => import('./library/CutConfirmationAlert'), 'CutConfirmationAlert'),
  [ICON_NAMES.Orientation]: lazyImport(() => import('./library/Orientation'), 'Orientation'),
  [ICON_NAMES.Question1]: lazyImport(() => import('./library/Question1'), 'Question1'),
  [ICON_NAMES.PhotoPaper]: lazyImport(() => import('./library/PhotoPaper'), 'PhotoPaper'),
  [ICON_NAMES.PrintType]: lazyImport(() => import('./library/PrintType'), 'PrintType'),
  [ICON_NAMES.GridView25]: lazyImport(() => import('./library/GridView25'), 'GridView25'),
  [ICON_NAMES.SelectAll]: lazyImport(() => import('./library/SelectAll'), 'SelectAll'),
  [ICON_NAMES.FormatTextAlignCenter]: lazyImport(
    () => import('./library/FormatTextAlignCenter'),
    'FormatTextAlignCenter',
  ),
  [ICON_NAMES.FormatTextAlignLeft]: lazyImport(() => import('./library/FormatTextAlignLeft'), 'FormatTextAlignLeft'),
  [ICON_NAMES.FormatTextAlignRight]: lazyImport(() => import('./library/FormatTextAlignRight'), 'FormatTextAlignRight'),
  [ICON_NAMES.IconText]: lazyImport(() => import('./library/IconText'), 'IconText'),
  [ICON_NAMES.Link]: lazyImport(() => import('./library/Link'), 'Link'),
  [ICON_NAMES.NotificationBadge]: lazyImport(() => import('./library/NotificationBadge'), 'NotificationBadge'),
  [ICON_NAMES.IncognitoModeAlert]: lazyImport(() => import('./library/IncognitoModeAlert'), 'IncognitoModeAlert'),
  [ICON_NAMES.NotSupportedEnvAlert]: lazyImport(() => import('./library/NotSupportedEnvAlert'), 'NotSupportedEnvAlert'),
  [ICON_NAMES.KitType]: lazyImport(() => import('./library/KitType'), 'KitType'),
  [ICON_NAMES.CheckCircle]: lazyImport(() => import('./library/CheckCircle'), 'CheckCircle'),
};

export type IconName = keyof typeof iconLibrary;
